var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { MenuItem, Button, ButtonGroup, Popper, Grow, Paper, ClickAwayListener, MenuList, } from '@mui/material';
import React, { useState, useRef } from 'react';
import { useIntl } from 'react-intl';
import { useDrawer } from 'context/DrawerContext';
import DrawerTypeEnum from 'types/enums/DrawerTypeEnum';
import sharedMessages from 'translations/shared';
import { ExpandMore, ExpandLess } from '@mui/icons-material';
export var Actions = function () {
    var formatMessage = useIntl().formatMessage;
    var openDrawer = useDrawer().openDrawer;
    var _a = __read(useState(false), 2), open = _a[0], setOpen = _a[1];
    var anchorRef = useRef(null);
    var handleToggle = function () {
        setOpen(function (prevOpen) { return !prevOpen; });
    };
    var handleClose = function (event) {
        if (anchorRef.current &&
            anchorRef.current.contains(event.target)) {
            return;
        }
        setOpen(false);
    };
    return (_jsxs(_Fragment, { children: [_jsxs(ButtonGroup, __assign({ variant: "contained", ref: anchorRef, "aria-label": "Actions", "data-cypress": "quick-actions-group" }, { children: [_jsx(Button, __assign({ onClick: function () {
                            openDrawer(DrawerTypeEnum.CREATE_APPOINTMENT, {});
                        }, "data-cypress": "topnav.actions.create-appointment" }, { children: formatMessage(sharedMessages.addAppointment) }), void 0), _jsx(Button, __assign({ size: "small", "aria-controls": open ? 'split-button-menu' : undefined, "aria-expanded": open ? 'true' : undefined, "aria-label": "select action", "aria-haspopup": "menu", onClick: handleToggle }, { children: open ? _jsx(ExpandLess, {}, void 0) : _jsx(ExpandMore, {}, void 0) }), void 0)] }), void 0), _jsx(Popper, __assign({ sx: { zIndex: 1 }, open: open, anchorEl: anchorRef === null || anchorRef === void 0 ? void 0 : anchorRef.current, role: undefined, transition: true, disablePortal: true }, { children: function (_a) {
                    var TransitionProps = _a.TransitionProps, placement = _a.placement;
                    return (_jsx(Grow, __assign({}, TransitionProps, { style: {
                            transformOrigin: placement === 'bottom' ? 'center top' : 'center bottom',
                        } }, { children: _jsx(Paper, { children: _jsx(ClickAwayListener, __assign({ onClickAway: handleClose }, { children: _jsx(MenuList, __assign({ id: "split-button-menu", autoFocusItem: true }, { children: _jsx(MenuItem, __assign({ onClick: function () {
                                            openDrawer(DrawerTypeEnum.CREATE_CLIENT, {});
                                        } }, { children: formatMessage(sharedMessages.addClient) }), void 0) }), void 0) }), void 0) }, void 0) }), void 0));
                } }), void 0)] }, void 0));
};
